import React, { useEffect } from "react";
import { FormBox } from "./FormBox";
import { PageHeader } from "./PageHeader";
import { YhBox } from "@/components/YhBox";
import { Button } from "antd";
import { SettingOptModeEnum, useSettingModel } from "../settingModel";
import { TreePanel } from "./TreePanel";
import { filterTree } from "../../dict/dictModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export function BaseSetting() {
    const {
        selectedRowKeys,
        loadData,
        dataSource,
        syncData,
        setOptMode,
        setSelectedRowKeys,
        setSelectedData,
    } = useSettingModel();
    const onInsert = () => {
        setOptMode(SettingOptModeEnum.ADD);
    }

    useEffect(() => {
        loadData().then(retData => {
            if (retData && retData.length > 0) {
                const firstCode = retData[0].code
                if (firstCode) {
                    setSelectedRowKeys([firstCode])
                }
            }
        });
    }, []);

    useEffect(() => {
        setSelectedData(filterTree(dataSource, selectedRowKeys[0]))
    }, [selectedRowKeys]);

    const action = (
        <>
            <YhAuth resCode={ResourceAuthEnum.DATA_SYS_ADD} >
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onInsert}
                >
                    新增
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.DATA_SYS_REFRESH} >
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => loadData()}
                >
                    刷新
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.DATA_SYS_SYNC} >
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={syncData}
                >
                    同步
            </Button>
            </YhAuth>
        </>
    );
    return (
        <>
            <PageHeader />
            <YhBox title=" " action={action}>
                <div className="tree-container flex">
                    <TreePanel />
                    <FormBox />
                </div>
            </YhBox>
        </>
    )
}